import * as React from 'react';
import { useSelector } from 'react-redux';
import { LinkButton } from '@cian/ui-kit';
import { IconActionMap16 } from '@cian/ui-kit-design-tokens/icons';
import { trackListingUrlClick, trackMapUrlClick } from './tracking';
import { selectListingsUrls } from '../../selectors/listingsUrls';

export const ListingsLinksContainer: React.FC = () => {
  const links = useSelector(selectListingsUrls);

  return (
    <>
      {links.listingUrl && (
        <LinkButton
          href={links.listingUrl}
          theme="fill_secondary"
          target="_blank"
          size="M"
          onClick={trackListingUrlClick}
          data-testid="ListingEntry"
        >
          Смотреть ЖК с акциями
        </LinkButton>
      )}
      {links.mapUrl && (
        <LinkButton
          href={links.mapUrl}
          theme="fill_secondary"
          target="_blank"
          size="M"
          beforeIcon={<IconActionMap16 color="icon-main-default" />}
          onClick={trackMapUrlClick}
          data-testid="MapEntry"
        >
          Скидки на карте
        </LinkButton>
      )}
    </>
  );
};
